<template>
	<div class="account__section autorefresh display" style="margin-top: 15px">
		<div @click="$store.commit('settings/changeTheme')">
			<h3
				class="account__section__title"
				style="display: flex; flex-direction: column"
			>
				Recommendation
			</h3>
			<p class="account__section__desc">Turn On/Off recommendations</p>
		</div>
		<div
			:class="{
				inactive: settings.seeRecommendations,
			}"
			class="input-group__checkbox autorefresh__checkbox"
			@click="$store.commit('settings/activateCard')"
		>
			<input
				v-model="settings.seeRecommendations"
				class="input-group__checkbox__input"
				type="checkbox"
			/>
			<label
				class="input-group__checkbox__label"
				:class="{
					'input-group__checkbox__label--active': !settings.seeRecommendations,
				}"
			>
			</label>
			<svg
				width="12"
				height="10"
				viewBox="0 0 12 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				v-show="!settings.seeRecommendations"
			>
				<path
					d="M12 1.42L10.59 0L4 6.59L1.42 4.02L0 5.43L4 9.42L12 1.42Z"
				></path>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		settings() {
			return this.$store.getters["settings/settings"];
		},
	},
};
</script>
